module.exports = __webpack_public_path__ + "static/text-9a325ac292dfc5405148f7784ffad599.png";